import React from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import {Form, Field} from 'simple-react-form'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Button from 'orionsoft-parts/lib/components/Button'
import withOrganization from 'App/Decorators/withOrganization'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import {withRouter} from 'react-router'
import Select from 'orionsoft-parts/lib/components/fields/Select'

@withRouter
@withOrganization
@withMutation(gql`
  mutation addMember($email: String, $organizationId: ID, $roles: [String]) {
    addMember(email: $email, organizationId: $organizationId, roles: $roles) {
      success
    }
  }
`)
@withMessage
export default class AddMember extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    organization: PropTypes.object,
    addMember: PropTypes.func
  }

  @autobind
  async addMember() {
    this.setState({loading: true})
    try {
      await this.props.addMember(
        {
          email: this.state.email,
          organizationId: this.props.organization._id,
          roles: [this.state.role]
        },
        {
          refetchQueries: ['usersCount']
        }
      )
      this.props.router.push(`/organization/users`)
      this.props.showMessage('Success, invitation send')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  render() {
    return (
      <div>
        <div className="section">
          <div className="header">
            <h3>Agregar Miembro</h3>
          </div>
          <div className="content">
            <Form
              state={this.state}
              onChange={changes => this.setState(changes)}
              onSubmit={this.addMember}
            >
              <div className="row">
                <div className="col-xs-6 col-sm-">
                  <div className="label">Email</div>
                  <Field
                    fieldName="email"
                    fieldType="email"
                    type={Text}
                    placeholder="ej: pedro@tufirma.digital"
                  />
                </div>
                <div className="col-xs-6 col-sm-">
                  <div className="label">Rol</div>
                  <Field
                    fieldName="role"
                    label=""
                    key="role"
                    style={{width: '100%'}}
                    type={Select}
                    placeholder="Seleccionar"
                    options={[{value: 'admin', label: 'Admin'}, {value: 'member', label: 'Member'}]}
                  />
                </div>
              </div>
            </Form>
            <br />
            <Button
              primary
              onClick={this.addMember}
              disabled={!this.state || !this.state.email || !this.state.role}
            >
              Agregar Miembro
            </Button>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Organizations/Administration/AddMember/index.js